import { render, staticRenderFns } from "./ti2.vue?vue&type=template&id=c8a303ec&scoped=true&"
import script from "./ti2.vue?vue&type=script&lang=js&"
export * from "./ti2.vue?vue&type=script&lang=js&"
import style0 from "./ti2.vue?vue&type=style&index=0&id=c8a303ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a303ec",
  null
  
)

export default component.exports